import React, { Component } from 'react';
import * as d3 from 'd3';

class DotPlot extends Component {
  constructor(props) {
      super(props);
      this.createGraph = this.createGraph.bind(this);    
}

  componentDidMount() {
    if (this.props.data !== [] && this.props.data !== undefined) {
        this.createGraph();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.data !== [] && this.props.data !== undefined && (this.props.data !== prevProps.data || this.props.userData !== prevProps.userData)) {
        this.removeGraph();
        this.createGraph();
    }
  }

  createGraph() {
    const svg = d3.select("." + this.props.name + " svg"),
    margin = {
        top: 20,
        right: 20,
        bottom: 20,
        left: 20
    },
    width = this.props.width - margin.left - margin.right,
    height = this.props.height - margin.top - margin.bottom,
    g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg.attr("width", '100%')
    .attr("height", '100%')
    .attr('viewBox','0 0 ' + this.props.width +' '+ this.props.height)
    .attr('preserveAspectRatio','xMinYMin');

    const xScale = d3.scaleLinear().domain([0,16]).rangeRound([margin.left, width]);
    
    const yScale = d3.scaleBand()
    .domain(["Innovator", "Entrepreneur", "Visionary", "Hard Driver", "Competitor", "Producer", "Coordinator", "Monitor", "Organizer", "Facilitator", "Mentor", "Team Builder", "Authoritarian", "Partnership", "Delegative"])
    .rangeRound([height - margin.top, margin.bottom]);

    const typeScale = d3.scaleQuantize()
    .domain([0, 14])
    .range(["Innovator", "Entrepreneur", "Visionary", "Hard Driver", "Competitor", "Producer", "Coordinator", "Monitor", "Organizer", "Facilitator", "Mentor", "Team Builder", "Authoritarian", "Partnership", "Delegative"]);
    
    const xAxis = d3.axisBottom(xScale).ticks(10);
    const yAxis = d3.axisRight(yScale).ticks(15);

    g.append("g")
    .attr("transform", "translate(" + 0 + "," + 0 + ")")
    .call(yAxis);

    g.append("g")
    .attr("transform", "translate(" + 0 + "," + height + ")")
    .call(xAxis);

    if (this.props.userData !== undefined && this.props.userData.length !== 0) {
        let lines = g.append("g");
        for(let i = 0; i < this.props.data.length; i++) {
            const lineMaker = d3.line();
            const line = lineMaker([[xScale(this.props.data[i])-10,  yScale(typeScale(i)) - 10], [xScale(this.props.userData[i])-10,  yScale(typeScale(i)) - 10]]);
            lines.append('path').attr('d', line).attr('stroke', 'black');
        }
    }
    // Dot Plot
    let dots = g.append("g");
    dots.selectAll("circle")
        .data(this.props.data)
        .enter()
        .append("circle")
        .attr("cx", function(d,i) { return xScale(d) - 10; })
        .attr("cy", function(d,i) { return yScale(typeScale(i)) - 10;})
        .attr("r", "5")
        .style("fill", "#912424");
    if (this.props.userData !== undefined && this.props.userData.length !== 0) {
        let country_dots = g.append("g");
        country_dots.selectAll("circle")
        .data(this.props.userData)
        .enter()
        .append("circle")
        .attr("cx", function(d,i) { return xScale(d) - 10; })
        .attr("cy", function(d,i) { return yScale(typeScale(i)) - 10;})
        .attr("r", "5")
        .style("fill", "gold");
    }
    // Legend
    let legend = g.append("g");
    legend.append("rect")
        .attr("x", width - 110)
        .attr("y", 0)
        .attr("width", 10)
        .attr("height", 10)
        .style("fill", "gold");
    legend.append("text")
        .attr("x", width - 100)
        .attr("y", 10)
        .text(this.props.legend);
    legend.append("rect")
        .attr("x", width - 110)
        .attr("y", 15)
        .attr("width", 10)
        .attr("height", 10)
        .style("fill", "#912424");
    legend.append("text")
        .attr("x", width - 100)
        .attr("y", 25)
        .text("Global");
  }

  removeGraph() {
    var svg = d3.select("." + this.props.name + " svg"),
    g = svg.select("g");    
    g.remove();
}

  render() {
    return (
        <div className = {this.props.name}>
            <svg/>
        </div>
    );
  }
}

export default DotPlot;



// WEBPACK FOOTER //
// ./src/components/dotplot.js